import { Skeleton } from "@/components/ui/skeleton"

export function FilterSkeleton() {
  return (
    <div className={"w-96 bg-[#F7F7F7] p-4 rounded-2xl h-fit hidden sm:block"}>
      <div className="flex items-center justify-between mb-4  w-full">
        <Skeleton className="h-6 w-40" />
      </div>

      <div className="space-y-2 w-full">
        <div className="space-y-5">
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
        </div>
      </div>
    </div>
  )
}
